import {
	Button,
	IconButton,
	Modal,
	Paper,
	TextField,
	Typography,
	useTheme,
} from "@mui/material";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState } from "react";
import Region, { City } from "../interfaces/Region";
import {
	CreateRegionCity,
	DeleteRegionCity,
	GetRegions,
	UpdateRegionCity,
} from "../requester/functions";
interface IProps {}

enum Action {
	editRegion,
	editCity,
	createRegion,
	createCity,
}

const RegionsPage = (props: IProps) => {
	const theme = useTheme();

	const [openModal, setOpenModal] = useState<boolean>(false);
	const [regions, setRegions] = useState<Region[]>([]);
	const [cities, setCities] = useState<City[]>([]);

	const [editData, setEditData] = useState<string>("");
	const [selectedRegion, setSelectedRegion] = useState<number>(0);
	const [action, setAction] = useState<Action>(Action.createRegion);
	const [selectedId, setSelectedId] = useState<number>(0);

	const getRegions = () => {
		GetRegions({}, (resp) => {
			if (resp.status === "ok" && resp.data) {
				setRegions(resp.data);
			}
		});
	};

	useEffect(() => {
		const selected = regions.find((r) => r.id === selectedRegion);
		if (selected) setCities(selected?.cities);
		else setCities([]);
	}, [regions]);

	const actionSelect = () => {
		switch (action) {
			case Action.editRegion:
				UpdateRegionCity(
					{ id_region: selectedId, r_name: editData },
					onRequest
				);
				break;
			case Action.editCity:
				UpdateRegionCity({ id_city: selectedId, c_name: editData }, onRequest);
				break;
			case Action.createRegion:
				CreateRegionCity({ r_name: editData }, onRequest);
				break;
			case Action.createCity:
				CreateRegionCity(
					{ c_name: editData, id_region: selectedRegion },
					onRequest
				);
				break;
		}
	};

	const onRequest = (resp: any) => {
		if (resp.status === "ok") {
			getRegions();
		}
	};

	useEffect(() => {
		getRegions();
	}, []);

	return (
		<div className="flex justify-center gap-20">
			<Paper className="min-w-[300px]">
				<Typography className="text-center" variant={"h5"}>
					Регион
				</Typography>
				<div className="max-h-[500px] overflow-y-auto gap-2 flex flex-col py-2">
					{regions.map((r, i) => (
						<Paper
							key={`region-${i}`}
							sx={{
								background:
									r.id === selectedRegion ? theme.palette.primary.main : "",
							}}
							className="flex justify-between items-center px-2 py-1"
							onClick={() => {
								setSelectedRegion(r.id);
								setCities(r.cities);
							}}
						>
							<Typography>{r.name}</Typography>
							<div className="flex gap-2">
								<IconButton
									onClick={() => {
										setSelectedId(r.id);
										setAction(Action.editRegion);
										setEditData(r.name);
										setOpenModal(true);
									}}
								>
									<ModeEditIcon />
								</IconButton>
								<IconButton
									color="error"
									onClick={() => {
										DeleteRegionCity({ id_region: r.id }, onRequest);
										setSelectedRegion(0);
									}}
								>
									<DeleteIcon />
								</IconButton>
							</div>
						</Paper>
					))}
				</div>
				<Button
					variant="contained"
					sx={{
						width: "100%",
					}}
					onClick={() => {
						setAction(Action.createRegion);
						setEditData("");
						setOpenModal(true);
					}}
				>
					Добавить
				</Button>
			</Paper>
			<Paper className="min-w-[300px]">
				<Typography className="text-center" variant={"h5"}>
					Город
				</Typography>
				<div className="flex flex-col max-h-[500px] py-2 gap-2">
					{cities.map((c, i) => (
						<Paper
							key={`city-${i}`}
							className="flex justify-between items-center px-2 py-1"
						>
							<Typography>{c.name}</Typography>
							<div className="flex gap-2">
								<IconButton
									onClick={() => {
										setSelectedId(c.id);
										setAction(Action.editCity);
										setEditData(c.name);
										setOpenModal(true);
									}}
								>
									<ModeEditIcon />
								</IconButton>
								<IconButton
									color="error"
									onClick={() => {
										DeleteRegionCity({ id_city: c.id }, onRequest);
									}}
								>
									<DeleteIcon />
								</IconButton>
							</div>
						</Paper>
					))}
				</div>
				<Button
					variant="contained"
					sx={{
						width: "100%",
					}}
					disabled={!selectedRegion}
					onClick={() => {
						setAction(Action.createCity);
						setEditData("");
						setOpenModal(true);
					}}
				>
					Добавить
				</Button>
			</Paper>

			<Modal
				open={openModal}
				onClose={() => {
					setOpenModal(false);
				}}
				className="flex items-center justify-center "
			>
				<Paper className="focus-visible:outline-none p-5 min-w-[500px] min-h-[200px] flex flex-col items-center justify-between">
					<Typography>Введите название</Typography>
					<TextField
						label="Название"
						value={editData}
						onChange={(e) => {
							setEditData(e.target.value);
						}}
					></TextField>
					<Button
						variant="contained"
						disabled={!editData}
						onClick={() => {
							actionSelect();

							setOpenModal(false);
						}}
					>
						Сохранить
					</Button>
				</Paper>
			</Modal>
		</div>
	);
};

export default RegionsPage;
